/**
 * P1.3 — switch the active lens.
 *
 * Writes to the prefs store via a dedicated `_setLensId` setter that
 * only this command calls. Undoable so users can compare lenses with
 * Cmd-Z.
 */

import { BaseCommand, type ICommand } from '../../../../core/commands/ICommand';
import { useCompassViewPrefs } from '../../../../stores/compassViewPrefsStore';

export class ChangeExplorerLensCommand extends BaseCommand {
  readonly kind = 'compass:change-lens';
  private readonly prevLensId: string;
  private readonly nextLensId: string;

  constructor(nextLensId: string, prevLensId?: string) {
    super('Change lens', `Lens → ${nextLensId}`);
    this.nextLensId = nextLensId;
    this.prevLensId = prevLensId ?? useCompassViewPrefs.getState().lensId;
  }

  execute(): void {
    useCompassViewPrefs.getState()._setLensId(this.nextLensId);
  }

  undo(): void {
    useCompassViewPrefs.getState()._setLensId(this.prevLensId);
  }

  redo(): void {
    this.execute();
  }

  canMergeWith(other: ICommand): boolean {
    return other instanceof ChangeExplorerLensCommand;
  }

  mergeWith(other: ICommand): ICommand {
    if (!(other instanceof ChangeExplorerLensCommand)) return this;
    const merged = new ChangeExplorerLensCommand(other.nextLensId, this.prevLensId);
    merged.timestamp = other.timestamp;
    return merged;
  }

  override getMetadata(): Record<string, unknown> {
    return { kind: this.kind, prev: this.prevLensId, next: this.nextLensId };
  }
}
